export default "__VITE_ASSET__maKbZ9F3__"